const AOS = require('aos');
const $ = require('jquery');
// const _ = require('lodash');

require('@popperjs/core');
require('bootstrap');
require('slick-carousel');
require('magnific-popup');

window.jQuery = $;

$(function () {
  loadAOS();
  initSliders();
  initGoogleMapping();
  containerFix();
  submenuOffset();
  heroOffset();
  headerFix();

  // Runs server image replace function based on domain
  // if (window.location.hostname === 'cybake.test' || window.location.hostname === 'localhost') {
  //   imageReplace('cybake', 'cybake');
  // }

  // handler for the resize window event
  $(window).on("resize", function () {
    containerFix();
    headerFix();
  });
  // handler for the scroll window event
  $(window).on("scroll", function () {
    checkWindowScroll();
    uncoverElements();
  });

  // This adds margin top to first section tag inside body
  function headerFix() {
    let header = $("header");
    let headerHeight = $(header).outerHeight();
    var firstSection = $('body').find('section').first();
    $(firstSection).css("margin-top", `${headerHeight}px`);
  }
  
  // Inactivity popup
  let timeout;
  const sectionUserInactivity = document.getElementById("sectionUserInactivity");
  const sectionUserInactivityClose = document.getElementById("sectionUserInactivityClose");

  if (sectionUserInactivity) {
    function resetTimer() {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        if (!sectionUserInactivity.classList.contains("active")) {
          sectionUserInactivity.classList.add("active");
        }
      }, 1000000);
    }
    
    if (!sectionUserInactivity.classList.contains("active")) {
      document.addEventListener("mousemove", resetTimer);
      document.addEventListener("keydown", resetTimer);
      document.addEventListener("scroll", resetTimer);
      document.addEventListener("click", resetTimer);
      resetTimer();
    }//if

    sectionUserInactivityClose.addEventListener('click', (ev) => {
      sectionUserInactivity.classList.remove("active");
      resetTimer();
    });


  }//if

  // Quantity fields
  const minusBtn = document.querySelector(".minus");
  const plusBtn = document.querySelector(".plus");
  const inputField = document.querySelector(".quantity-input");
  const updateButton = document.querySelector("button[name='update_cart']"); // Check for update button

  if (minusBtn && plusBtn && inputField) {
    
    function enableUpdateButton() {
      if (updateButton) {
        updateButton.removeAttribute("disabled"); // Enable the button
      }
    }

    minusBtn.addEventListener("click", function () {
      let currentValue = parseInt(inputField.value);
      if (currentValue > 1) {
        inputField.value = currentValue - 1;
        enableUpdateButton();
      }
    });

    plusBtn.addEventListener("click", function () {
      let currentValue = parseInt(inputField.value);
      inputField.value = currentValue + 1;
      enableUpdateButton();
    });

    inputField.addEventListener("change", enableUpdateButton);
    inputField.addEventListener("keyup", enableUpdateButton);
  }

  // Magnific
  $('.magnific').magnificPopup({
    type:'image',
    gallery: {
      enabled: true,
    }
  });

  // Smooth scroll.
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .on("click", function (event) {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        var offset = $("header").outerHeight();
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top - offset,
            },
            1000
          );
        }
      }
    });

  // Burger click
  $("#burger").click(function () {
    open = !open;
    toggleMenu(open);
  });

  // Active class.
  $("header .nav [href]").each(function () {
    if (this.href == window.location.href) {
      $(this).addClass("active");
    }
  });

  // Submenu.
  $(".submenu-toggle").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");
    $(this).prev(".parent-item").toggleClass("open");
    var submenu = $(this).next(".submenu");
    submenu.children("ul").slideToggle("fast");
  });

  // Category Search
  if($('#searchFilter').length > 0) {
    var dataId = $('#searchFilter').attr('data-id');
    cardsSearch('all', dataId);
  }

  $('#searchFilter').on('input change', function() {
    var input = $(this);
    setTimeout(function() {
      var searchEntered = input.val();
      var dataId = input.attr('data-id');
      cardsSearch(searchEntered, dataId);
    }, 1000);
  });

  function cardsSearch(search_query, search_term) {
    $.ajax({
      url: '/wp-content/themes/scripts/product-cat-search.php',
      type: "POST",
      data: { 
        search_query: search_query,
        search_term: search_term
      },
      success: function(response) {
        $(".search-results-inner").html(response);
      },
      error: function(xhr, status, error) {
        console.error(error);
      }
    });
  }

  // Product Search
  if($('#searchProductFilter').length > 0) {
    var filterCategory = 'all';

    if($('input[name="category-filter"]').length > 0) {
      filterCategory = $('input[name="category-filter"]:checked').val();
    } else if ($('select[name="category-filter"]').length > 0) {
      filterCategory = $('#searchProductFilter').val()?.trim() || 'all';
    }

    var dataCategory = $('#searchProductFilter').attr('data-category');
    cardsProductSearch('all', dataCategory, filterCategory);
  }

  $('#searchProductFilter').on('input change', function() {
    var input = $(this);
    var searchEntered = input.val();
    var dataCategory = input.attr('data-category');
    var filterCategory = $('input[name="category-filter"]:checked').val();

    cardsProductSearch(searchEntered, dataCategory, filterCategory);
  });

  if($('input[name="category-filter"]').length > 0) {
    $('input[name="category-filter"]').on('input change', function() {
      var input = $('#searchProductFilter');
      var searchEntered = input.val().trim();
  
      if (!searchEntered) {
        searchEntered = 'all';
      }
  
      var dataCategory = input.attr('data-category');
      var filterCategory = $(this).val();
      cardsProductSearch(searchEntered, dataCategory, filterCategory);
    });
  } else if ($('select[name="category-filter"]').length > 0) {
    $('select[name="category-filter"]').on('change', function() {
      var input = $('#searchProductFilter');
      var searchEntered = input.val()?.trim() || 'all';

      var dataCategory = input.attr('data-category') || '';
      var filterCategory = $(this).val();

      cardsProductSearch(searchEntered, dataCategory, filterCategory);
    });
  }

  function cardsProductSearch(search_query, search_term, search_filter) {
    $.ajax({
      url: '/wp-content/themes/scripts/product-search.php',
      type: "POST",
      data: { 
        search_query: search_query,
        search_term: search_term,
        search_filter: search_filter
      },
      success: function(response) {
        $(".product-search-results-inner").html(response);
      },
      error: function(xhr, status, error) {
        console.error(error);
      }
    });
  }

  $(document).on('click', '.product-card', function() {
    var productId = $(this).attr('data-id');
    productModal(productId);
  });

  $(document).on('click', '.modal-close', function() {
    $('.product-modal-wrapper').empty();
  });

  $(document).on('click', function(event) {
    if (!$(event.target).closest('.product-modal-inner').length) {
      $('.product-modal-wrapper').empty();
    }
  });

  function productModal(product_id) {
    $.ajax({
      url: '/wp-content/themes/scripts/product-modal.php',
      type: "POST",
      data: { 
        product_id: product_id
      },
      success: function(response) {
        $(".product-modal-wrapper").html(response);
      },
      error: function(xhr, status, error) {
        console.error(error);
      }
    });
  }

  $(document).on('click', '#minus, #plus', function(event) {
    event.preventDefault();

    var $button = $(this).closest('button');
    var $qtyInput = $button.siblings('#qty');
    var currentVal = parseInt($qtyInput.val()) || 1;
    var newVal = currentVal;

    if ($button.attr('id') === 'minus' && currentVal > 1) {
      newVal = currentVal - 1;
    } else if ($button.attr('id') === 'plus') {
      newVal = currentVal + 1;
    }

    if($('.single-product .qty-wrapper').length > 0) {
      setTimeout(function(){
        $('.single-product .cart input.qty').text(newVal);
        $('.single-product .cart input.qty').val(newVal);
      }, 500);
    }

    $qtyInput.val(newVal).trigger('change');
    updateAddToBasketUrl(newVal);
  });

  // Function to update the "Add to Basket" button URL
  function updateAddToBasketUrl(qty) {
    var $addToBasket = $('.product-modal-inner .add-to-basket');
    var currentUrl = new URL($addToBasket.attr('href'), window.location.origin);
    currentUrl.searchParams.set('quantity', qty);
    $addToBasket.attr('href', currentUrl.toString());
  }

  $(document).on('click', '.add-delivery', function(event) {
    event.preventDefault();
    $('.product-modal-inner').hide();
    $('.product-modal-date-select').show();
  });

  $(document).on('click', '.edit-product', function(event) {
    event.preventDefault();
    $('.product-modal-inner').show();
    $('.product-modal-date-select').hide();
  });

  // Check if the body has the 'single-product' class
  if ($('body').hasClass('single-product')) {
    
    // Get the URL parameters
    var urlParams = new URLSearchParams(window.location.search);
    var quantity = urlParams.get('quantity');
    
    // Update the quantity input field with the value from the URL
    setTimeout(function(){
      $('#product-details input.qty').text(quantity);
      $('#product-details input.qty').val(quantity);
    }, 500);
  }

  $('.product-info').on('click', function(){
    $('#product-details').show();
    $('#product-date-select').hide();
  });

  // Calendar
  var nextLead = null;
  function generateCalendar(calendarContainer, year, month) {
    let firstDay = new Date(year, month, 1).getDay(); // Get first day of the month
    let daysInMonth = new Date(year, month + 1, 0).getDate(); // Get total days in the month
    let prevDaysInMonth = new Date(year, month, 0).getDate(); // Get total days in the previous month
    let currentMonth = new Date().getMonth();
    let calendarBody = calendarContainer.find(".calendar-body");
    let monthYear = calendarContainer.find(".monthYear");
    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    monthYear.text(months[month] + " " + year);
    calendarBody.empty();

    let date = 1;
    let nextMonthDate = 1;
    let rowsNeeded = Math.ceil((daysInMonth + firstDay) / 7);
    
    // Get today's date and the lead value
    let currentDate = new Date();
    let today = currentDate.getDate();

    let lead = parseInt(calendarContainer.data("lead"), 10) || 0;
  
    // Calculate remaining days in the current month after today
    let remainingDaysInCurrentMonth = daysInMonth - today;

    // The first disabled day based on the lead time
    let leadStartDate = today;
    let leadEndDate = leadStartDate + lead;

    if (currentMonth == month) {
      nextLead = lead - remainingDaysInCurrentMonth;
    }

    if (leadEndDate > daysInMonth) {      
      $('.calendar-container').attr('data-lead-overflow', nextLead);
    }

    for (let i = 0; i < rowsNeeded; i++) {
        let row = $("<tr></tr>");

        for (let j = 0; j < 7; j++) {
            let cell = $("<td></td>");
            let cellDate;

            if (i === 0 && j < firstDay) {
              // Fill previous month's dates
              let prevMonthDay = prevDaysInMonth - (firstDay - j - 1);
              cell.text(prevMonthDay);
              cell.addClass("extra-date");
            } else if (date > daysInMonth) {
              // Fill next month's dates
              cell.text(nextMonthDate);
              cell.addClass("extra-date");
              nextMonthDate++;
            } else {
              // Fill current month's dates
              cell.text(date);
              cell.attr("data-date", `${year}-${month + 1}-${date}`);
              cellDate = date;

              // Get exclusion dates from data attribute
              let exclusionDates = [];
              try {
                let exclusionData = calendarBody.attr('data-exclusion-dates');
                if (exclusionData) {
                  exclusionDates = JSON.parse(exclusionData);
                }
              } catch (e) {
                console.warn('Error parsing exclusion dates:', e);
              }

              // Check if current date is in exclusion list
              let currentCellDate = `${year}-${(month + 1).toString().padStart(2, '0')}-${date.toString().padStart(2, '0')}`;
              if (exclusionDates.includes(currentCellDate)) {
                cell.addClass("disabled");
              }

              // Disable past dates
              if (month === currentDate.getMonth() && date < today || year < currentDate.getFullYear() || (year === currentDate.getFullYear() && month < currentDate.getMonth())) {
                cell.addClass("disabled");
              }

              // Disable today's date
              if (month === currentDate.getMonth() && date === today) {
                cell.addClass("disabled");
              }

              // Disable future dates based on the "data-lead"
              if (month === currentDate.getMonth() && date >= leadStartDate && date <= leadEndDate) {
                cell.addClass("disabled");
              }

              cell.click(function () {
                if (!$(this).hasClass("disabled")) {
                  calendarContainer.find("td").removeClass("selected");
                  $(this).addClass("selected");
                }
              });
              date++;
            }
          row.append(cell);
        }
      calendarBody.append(row);
    }

    // Handle disabling dates in the next month if nextLead is not null
    if (nextLead > 0) {
      let nextMonth = currentMonth + 1;
      let leadOverflow = $('.calendar-container').attr('data-lead-overflow');

      if (nextMonth > 11) {
        nextMonth = 0;
        year++;
      }

      if (nextMonth == month) {
        // Disable the first "nextLead" dates in the next month
        for (let i = 1; i <= leadOverflow; i++) {
          let nextMonthCell = $(`[data-date="${year}-${nextMonth + 1}-${i}"]`);
          nextMonthCell.addClass("disabled");
        }
      }
    }
  }

  $(".calendar-container").each(function () {
      let calendarContainer = $(this);
      let currentYear = new Date().getFullYear();
      let currentMonth = new Date().getMonth();

      // Generate the initial calendar for the current month
      generateCalendar(calendarContainer, currentYear, currentMonth);

      // Disable navigating backwards past the current month
      calendarContainer.find(".prevMonth").click(function () {
          // Check if the current month is already the current month or earlier
          let currentDate = new Date();
          if (currentYear < currentDate.getFullYear() || (currentYear === currentDate.getFullYear() && currentMonth < currentDate.getMonth())) {
              // Prevent moving to a month before the current month
              return;
          }

          // Move to the previous month
          currentMonth--;
          if (currentMonth < 0) {
              currentMonth = 11;
              currentYear--;
          }
          generateCalendar(calendarContainer, currentYear, currentMonth);
      });

      // Move to the next month
      calendarContainer.find(".nextMonth").click(function () {
          currentMonth++;
          if (currentMonth > 11) {
              currentMonth = 0;
              currentYear++;
          }
          generateCalendar(calendarContainer, currentYear, currentMonth);
      });
  });

  function getDayName(dateString) {
    var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var date = new Date(dateString);
    return days[date.getDay()];
  }

  $(document).on('click', '.tab-content .tab-pane.active td', function () {
    var dateSelected = $(this).attr('data-date'); // Get selected date from clicked <td>
    var dateDelivery = $('.tab-content .tab-pane.active').attr('data-delivery'); // Get delivery type
    var $addToBasket = $('.single-product .add-to-basket'); // Select Add to Basket button

    if ($addToBasket.length > 0 && $addToBasket.attr('href')) {
      // If button exists and has an href, update the URL
      var currentUrl = new URL($addToBasket.attr('href'), window.location.origin);
      currentUrl.searchParams.set('delivery_date', dateSelected);
      currentUrl.searchParams.set('delivery_type', dateDelivery);
      $addToBasket.attr('href', currentUrl.toString()); // Update the button's href
    } 
    
    if($('#custom-product-meta').length > 0) {
      // Always update the .build-product attributes
      $('#custom-product-meta').attr('data-delivery-type', dateDelivery);
      $('#custom-product-meta').attr('data-delivery-date', dateSelected);
    };

    if(dateDelivery == 'pick-up') {
      var dayName = getDayName(dateSelected);
      var parentContainer = $(this).closest('.inner-date-content');

      $.ajax({
        url: '/wp-content/themes/scripts/time-slots.php',
        method: 'POST',
        data: { day: dayName },
        success: function(response) {
          parentContainer.addClass('d-none').removeClass('d-block');
          $(".time-wrapper").html(response);
          $(".time-wrapper").removeClass('d-none').addClass('d-block');
        },
        error: function(xhr, status, error) {
          console.error("AJAX error:", status, error);
        }
      });
    } else {
      $('#custom-product-meta').attr('data-delivery-time', '');
    }
  });

  $(document).on('click', '.time-selection-return', function(){
    var returnButton = $(this);
    var timeSelect = returnButton.closest('.time-wrapper');
    var dateSelect = timeSelect.siblings('.inner-date-content');

    dateSelect.addClass('d-block').removeClass('d-none');
    timeSelect.addClass('d-none').removeClass('d-block');
  });

  $(document).on('click', '.tab-content .tab-pane.active .time-selection', function(){
    var timeSelected = $(this);
    var timeSelectedVal = timeSelected.attr('data-time');

    $('.time-selection').removeClass('selected');
    timeSelected.addClass('selected');

    if($('#custom-product-meta').length > 0) {
      $('#custom-product-meta').attr('data-delivery-time', timeSelectedVal);
    };
  });

  // Prevent navigation if values are missing
  $(document).on('click', '.single-product .add-to-basket', function (e) {
    var currentUrl = new URL($(this).attr('href'), window.location.origin);

    var deliveryDate = currentUrl.searchParams.get('delivery_date');
    var deliveryType = currentUrl.searchParams.get('delivery_type');

    if (!deliveryDate || !deliveryType) {
      e.preventDefault(); // Stop link navigation

      var dateSelected = $('.tab-content .tab-pane.active td.selected').attr('data-date');

      if (!dateSelected) {
        $('.error-message').show();
      }
    }
  });

  // Single Product Qty
  function singleQtyBtn() {
    $(".single-product .quantity").each(function () {
      if (!$(this).find(".minus").length) { // Prevent duplicate buttons
        $(this).append('<button class="minus">-</button>');
        $(this).append('<button class="plus">+</button>');
      }
    });
  }

  if($('#product-builder').length > 0) {
    setTimeout(function () {
      singleQtyBtn();
    }, 500);
  
    const observer = new MutationObserver(function(mutationsList) {
      setTimeout(function () {
        singleQtyBtn();
      }, 500);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Use event delegation to handle dynamically added elements
  $(document).on("click", ".single-product .quantity .minus", function (event) {
    event.preventDefault();
    let inputField = $(this).siblings(".qty"); // Find the closest input field
    let currentValue = parseInt(inputField.val()) || 0;
    if (currentValue > 1) {
      inputField.val(currentValue - 1);
    }
  });

  $(document).on("click", ".single-product .quantity .plus", function (event) {
    event.preventDefault();
    let inputField = $(this).siblings(".qty"); // Find the closest input field
    let currentValue = parseInt(inputField.val()) || 0;
    inputField.val(currentValue + 1);
  });

  setTimeout(function(){
    $(".component_options_select").each(function () {
      let hasPrice = false;
      let hasSimpleProduct = false;
  //updated 2
      // Check if this component has simple products by looking at data attributes
      let $componentOptions = $(this).closest(".component_options");
      let optionsData = $componentOptions.data("options_data");
      
      // If we have options data, check for simple products
      if (optionsData && Array.isArray(optionsData)) {
        optionsData.forEach(function(option) {
          if (option.option_product_data && option.option_product_data.product_type === "simple") {
            hasSimpleProduct = true;
          }
        });
      }

      $(this).find("option").each(function () {
        let text = $(this).text();
        if (text.indexOf("£") !== -1 && text.indexOf("message") === -1 && text.indexOf("image") === -1) {
          hasPrice = true;
          return false;
        }
      });

      // Only hide if there's no price AND no simple products
      if (!hasPrice && !hasSimpleProduct) {
        $componentOptions.hide();
      } else {
        // Ensure the component is visible and titles are shown
        $componentOptions.show();
        
        // Make sure both title types are visible
        $componentOptions.find(".composited_product_title").show();
        $componentOptions.find(".component_title_wrapper").show();
        $componentOptions.find(".step_title_wrapper").show();
      }
    });
  }, 500);

  //force recompile

  // Define an array of all custom components to loop over
  var componentSelectors = [".custom-component-title", ".custom-component-subtitle", ".custom-component-html"];

  // Loop over each .composite_component, starting the index at 1
  $(".composite_component").each(function (index) {
    // Increment the index to start from 1 (because jQuery .each() is 0-based)
    var currentIndex = index + 1;
    var currentHtml = $(this);

    // Loop over each selector in the componentSelectors array
    $(componentSelectors.join(', ')).each(function () {
      // Get the data-append attribute from the current component
      var dataAppendValue = $(this).data("append");

      // Check if data-append matches the current index
      if (dataAppendValue == currentIndex) {
        // Append the current element to the .component_summary of the current .composite_component
        $(this).appendTo(currentHtml.find(".component_summary"));
      }
    });
  });

  // Removing price
  setTimeout(function(){
    if ($(".quantity_hidden").length) {
      $(".quantity_hidden").closest(".single_variation_wrap").addClass("d-none");
    }
  }, 500);

  // Passing personalised message as meta data
  $(document).on("input", "textarea#personalised-message", function () {
    var messageValue = $(this).val()?.trim() || '';
    
    // Always update the data attribute when user types, regardless of select state
    // The select validation will be handled when the form is submitted
    if (messageValue) {
      $("#custom-product-meta").attr("data-product-message", messageValue);
    } else {
      $("#custom-product-meta").removeAttr("data-product-message");
    }
  });

  var currentHash = window.location.hash;
  var stepID = null;

  $(window).on('hashchange', function() {
    var newHash = window.location.hash;

    if (newHash !== currentHash) {
      // Update the stored hash
      currentHash = newHash;

      $('.pagination_element').each(function(){
        var step = $(this);
        var stepHref = step.find('.element_link').attr('href'); // use correct selector and attr()

        // Make sure we only compare the hash part
        var stepHash = stepHref ? stepHref.split('#')[1] : null;

        if (stepHash && ('#' + stepHash) === currentHash) {
          stepID = step.attr('data-item_id');
        }
      });
    }

    $('.composite_component').each(function(){
      var parent = $(this);
      var parentID = parent.attr('data-item_id');

      if(parentID == stepID) {
        $('.custom-component-title').addClass('d-none');
        $('.custom-component-subtitle').addClass('d-none');
        $('#personalised-message-wrapper').removeClass('d-flex').addClass('d-none');
      }
    });
  });

  $(document).on('change', '.variations_form .variations select', function () {
    var select = $(this);
    var selectedOption = select.val();
    var parent = select.closest('.component_content');
    var parentID = parent.attr('data-product_id');

    const selectedOptionIncludesYes = selectedOption.includes('Yes');

    if(parentID == stepID) {
      if(selectedOptionIncludesYes) {
        $('.custom-component-title').removeClass('d-none');
        $('.custom-component-subtitle').removeClass('d-none');
        $('#personalised-message-wrapper').addClass('d-flex').removeClass('d-none');
      } else {
        $('.custom-component-title').addClass('d-none');
        $('.custom-component-subtitle').addClass('d-none');
        $('#personalised-message-wrapper').removeClass('d-flex').addClass('d-none');
      }
    }
  });

  jQuery(function($) {
    const $target = $('.form_input_blocker');
  
    if ($target.length > 0) {
      const observer = new MutationObserver(function() {
        // === Step 1: Personalised Image ===
        const $headingImage = $('h4.product_title:contains("Personalised image")');
        const $selectImage = $('select[name="wccp_attribute_options[1739980194]"]');
        const selectedTextImage = $selectImage.find('option:selected').text().toLowerCase();
  
        const headingImageVisible = $headingImage.length && $headingImage.is(':visible');
        const imageOptionIncludesYes = selectedTextImage.includes('yes');
  
        if (headingImageVisible && imageOptionIncludesYes) {
          console.log('✅ Personalised image: heading visible AND option includes yes');
          $(".personalised_wrap").removeClass("d-none");
        } else {
          $(".personalised_wrap").addClass("d-none");
          console.log(headingImageVisible ? '👀 Personalised image: heading visible, but option does not include yes' : '❌ Personalised image: heading not showing');
        }
  
        // === Step 2: Personalised Message ===
        const $headingMessage = $('h4.product_title:contains("Personalised message")');
        const $selectMessage = $('select[name="wccp_attribute_options[1739980195]"]');
        const selectedTextMessage = $selectMessage.find('option:selected').text().toLowerCase();
  
        const headingMessageVisible = $headingMessage.length && $headingMessage.is(':visible');
        const messageOptionIncludesYes = selectedTextMessage.includes('yes');
  
        if (headingMessageVisible && messageOptionIncludesYes) {
          console.log('✅ Personalised message: heading visible AND option includes yes');
          $(".personalised_mess").removeClass("d-none");
        } else {
          $(".personalised_mess").addClass("d-none");
          console.log(headingMessageVisible ? '👀 Personalised message: heading visible, but option does not include yes' : '❌ Personalised message: heading not showing');
        }
      });
  
      observer.observe($target[0], {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style']
      });
    }
  });

  $(".personalised_wrap").addClass("d-none");

  $(document).on("change", ".variations #options", function () {
    
    var closestComponent = $(this).closest(".composite_component");
    //alert('fired change');
    // Get the selected option text
    var selectedOption = $(this).find("option:selected").text().toLowerCase();
    
    // console.log('selected option')
    // console.log(selectedOption);
  
    // Get the current textarea value safely
    var messageValue = closestComponent.find('textarea#personalised-message').val();
    if (messageValue !== undefined) {
      messageValue = messageValue.trim(); // Safely trim the value
    }
    
    if(selectedOption == 'yes please (+ £2.50)')
    {
      $(".personalised_wrap").removeClass("d-none");
    }
    else
    {
      $(".personalised_wrap").addClass("d-none");
    }
    
    if(selectedOption == 'yes please, my message is (+ £2.50)')
    {
      $(".personalised_mess").removeClass("d-none");
    }
    else
    {
      $(".personalised_mess").addClass("d-none");
    }
  
    // Only update the data attribute if we have a valid message value and the option includes "yes"
    if (selectedOption.includes("yes") && messageValue !== undefined && messageValue !== '') {
      $("#custom-product-meta").attr("data-product-message", messageValue);
    }
    // Don't remove the attribute if the option doesn't include "yes" - let the user's input persist
    
    // Handle image upload reset only for image components
    if (!selectedOption.includes("yes") && closestComponent.find('.image-upload').length > 0) {
      // Reset the image-upload form
      $('form.image-upload').trigger('reset');
    }
  });
  
  
  function updatePersonalisedWrapVisibility() {
    // First, hide by default
    $(".personalised_wrap").addClass("d-none");
  
    // Find the active composite component
    const $activeComponent = $(".composite_component:visible");
  
    if ($activeComponent.length) {
      const isPersonalisedStep = $activeComponent
        .find(".composited_product_title")
        .text()
        .toLowerCase()
        .includes("personalised image");
  
      if (isPersonalisedStep) {
        const selectedText = $activeComponent
          .find('select#options option:selected')
          .text()
          .toLowerCase();
  
        if (selectedText.includes("yes")) {
          $(".personalised_wrap").removeClass("d-none");
        }
      }
    }
  }
  
  $('.review-title').prependTo($('.composite_summary'));

  setTimeout(function(){
    $('.content_product_title').each(function() {
      var $span = $(this);
      
      // Check if the span contains a <ul> element
      if ($span.find('ul').length > 0) {
        // Remove text nodes from the span but keep the <ul>
        $span.contents().each(function() {
          if (this.nodeType === 3) { // Check if it's a text node
            $(this).remove();
          }
        });
      }
    });
  }, 500);

  // Layout Initial State
  $('.build-product').on('click', function(event){
    event.preventDefault();

    var dateSelected = $('.tab-content .tab-pane.active td.selected').attr('data-date');

    if (dateSelected) {
      $('#product-date-select').addClass('d-none');
      $('#product-builder').removeClass('d-none');
      $('#product-builder').addClass('d-flex');
    } else {
      $('.error-message').show();
    }
  });  

  // When .add-to-basket is clicked
  $('.single-product .add-to-basket').on('click', function(e) {
    e.preventDefault();  // Prevent the default action (if any) on .add-to-basket

    // Trigger the click event on .single_add_to_cart_button
    $('.single_add_to_cart_button').trigger('click');
  });

  $('.single_add_to_cart_button').on('click', function(e) {
    let customMeta = $('#custom-product-meta');
    
    if (customMeta.length) {
      // Get the raw values
      let deliveryDate = customMeta.attr('data-delivery-date');
      let deliveryTime = customMeta.attr('data-delivery-time');
      let deliveryType = customMeta.attr('data-delivery-type');

      // Convert delivery date from YYYY-MM-DD to DD/MM/YYYY
      if (deliveryDate) {
        let dateParts = deliveryDate.split('-');
        deliveryDate = dateParts[2] + '/' + dateParts[1] + '/' + dateParts[0]; // DD/MM/YYYY
      }

      // Convert delivery type (e.g., "pick-up" to "Pick Up")
      if (deliveryType) {
        deliveryType = deliveryType.replace('-', ' ').replace(/\b\w/g, char => char.toUpperCase());
      }

      // Create an object with the transformed data
      let data = {
        'delivery-date': deliveryDate,
        'delivery-time': deliveryTime,
        'delivery-type': deliveryType,
        'product-message': customMeta.attr('data-product-message'),
        'product-img': customMeta.attr('data-product-img')
      };

      // Create a hidden input field to pass the serialized data
      let input = $('<input>').attr({
        type: 'hidden',
        name: 'custom-product-meta',
        value: $.param(data) // Convert object to URL encoded string
      });

      $(this).closest('form.cart').append(input);
    }
  });

  // Skip Date Change
  $('.skip-build-product').on('click', function(event){
    event.preventDefault();

    $('#product-date-select').addClass('d-none');
    $('#product-builder').removeClass('d-none');
    $('#product-builder').addClass('d-flex');
  });

  // Product Update
  // setTimeout(function(){
  //   $('#custom-product-meta').each(function() {
  //     // Get the data-* attribute for each input
  //     $(this).each(function() {
  //       // For each input, loop through all data- attributes and log them
  //       $.each(this.attributes, function() {
  //         // Check if the attribute name starts with 'data-'
  //         if (this.name.startsWith('data-')) {
  //           console.log(this.name + ': ' + this.value);
  //         }
  //       });
  //     });
  //   });
  // }, 500);

  $.fn.isScrolledIntoView = function () {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(this).offset().top;
    return elemTop <= docViewBottom && elemTop >= docViewTop;
  };
});

/**
 * @description loads the AOS library after a set timeout
 */
let loadAOS = () => {
  setTimeout(() => {
    $("body").addClass("loaded");
    setTimeout(() => {
      AOS.init();
    }, 500);
  }, 1000);
};

/**
 * @description loads timages via the server over local files
 */
let imageReplace = (liveDomain, localDomain) => {
  const live = liveDomain;
  const local = localDomain;

  // Replace domain in <img> src attributes
  $('img').each(function () {
    const currentSrc = $(this).attr('src');

    // Update test domain
    if (currentSrc && currentSrc.includes(local + '.test')) {
      $(this).attr('src', currentSrc.replace(local + '.test', live + 'demo.frogspark.agency'));
    }

    // Update local domain
    if (currentSrc && currentSrc.includes('localhost:3000')) {
      $(this).attr('src', currentSrc.replace('localhost:3000', live + 'demo.frogspark.agency'));
    }
  });

  // Replace domain in <video> src attributes
  $('video').each(function () {
    const currentSrc = $(this).attr('src');
    const currentPoster = $(this).attr('poster');

    // Update test domain
    if (currentSrc && currentSrc.includes(local + '.test')) {
      $(this).attr('src', currentSrc.replace(local + '.test', live + 'demo.frogspark.agency'));
    }

    if (currentPoster && currentPoster.includes(local + '.test')) {
      $(this).attr('poster', currentPoster.replace(local + '.test', live + 'demo.frogspark.agency'));
    }

    // Update local domain
    if (currentSrc && currentSrc.includes('localhost:3000')) {
      $(this).attr('src', currentSrc.replace('localhost:3000', live + 'demo.frogspark.agency'));
    }

    if (currentPoster && currentPoster.includes('localhost:3000')) {
      $(this).attr('poster', currentPoster.replace('localhost:3000', live + 'demo.frogspark.agency'));
    }
  });

  // Replace domain in <div> background-image style attributes
  $('div').each(function () {
    const currentBg = $(this).css('background-image');

    // Update test domain
    if (currentBg && currentBg.includes(local + '.test')) {
      const updatedBg = currentBg.replace(local + '.test', live + 'demo.frogspark.agency');
      $(this).css('background-image', updatedBg);
    }

    // Update local domain
    if (currentBg && currentBg.includes('localhost:3000')) {
      const updatedBg = currentBg.replace('localhost:3000', live + 'demo.frogspark.agency');
      $(this).css('background-image', updatedBg);
    }
  });

  // Replace domain in <a> src attributes
  $('a').each(function () {
    const currentSrc = $(this).attr('href');

    // Update test domain
    if (currentSrc && currentSrc.includes(live + 'demo.frogspark.agency') && window.location.hostname === local + '.test') {
      $(this).attr('href', currentSrc.replace(live + 'demo.frogspark.agency', local + '.test'));
    }

    // Update test domain
    if (currentSrc && currentSrc.includes(live + 'demo.frogspark.agency') && window.location.hostname === 'localhost') {
      $(this).attr('href', currentSrc.replace(live + 'demo.frogspark.agency', 'localhost:3000'));
    }
  });
};

/**
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
 */
let checkWindowScroll = () => {
  let scroll = $(window).scrollTop();
  if (scroll > 0) {
    $("header").addClass("scroll");
  } else {
    $("header").removeClass("scroll");
  }
};

/**
 * @description function for fixing floating elements or page width elements with content to the conventional bootstrap container sizes
 */
let containerFix = () => {
  if ($('.container-fix').length) {
    let containerWidths = {
      576: 540,
      768: 720,
      992: 960,
      1200: 1140,
      1440: 1440,
    };
    let windowWidth = $(window).width();
    let containerWidth = 0;
    for (const [key, value] of Object.entries(containerWidths)) {
      if (windowWidth >= key) {
        containerWidth = value;
      }
    }

    var padding = ((windowWidth - containerWidth) / 2) + 32;
    if (windowWidth >= 992) {
      $('.container-fix').each(function () {
        if ($(this).hasClass('odd')) {
          $(this).css('padding-left', '0px');
          $(this).css('padding-right', padding + 'px');
        } else if ($(this).hasClass('even')) {
          $(this).css('padding-left', padding + 'px');
          $(this).css('padding-right', '0px');
        }
      });
    } else if (windowWidth >= 576 && windowWidth <= 991) {
      $('.container-fix').each(function () {
        $(this).css('padding-left', padding + 'px');
        $(this).css('padding-right', padding + 'px');
      });
    } else {
      $('.container-fix').each(function () {
        $(this).css('padding-left', '32px');
        $(this).css('padding-right', '32px');
      });
    }
  }
};

/**
 *  @description affix appropriately css positioned elements (ie position = fixed || absolute) below the header banner
 */
let submenuOffset = () => {
  let headerHeight = $("#header").outerHeight();
  let dropdown = $(".submenu");
  let scroll = $(document).scrollTop();
  let topstripHeight = 0;

  if (scroll == 0) {
    dropdown.css("top", headerHeight + "px");
  } else if (scroll < topstripHeight) {
    dropdown.css("top", scroll + headerHeight + "px");
  } else {
    dropdown.css("top", headerHeight + "px");
  }
};

/**
 * @description offset elements labeled with the offset hero class by the height of the header
 */
let heroOffset = () => {
  let hero = $(".offset-hero");
  let header = $("header");

  if (hero.length && header.length) {
    let height = $(header).outerHeight();
    $(hero).css("margin-top", `${height}px`);
  }
};

/**
 * @description reveals hidden page elements
 */
let uncoverElements = () => {
  $(".uncover").each(function () {
    if ($(this).isScrolledIntoView() === true) {
      $(this).addClass("show");
    }
  });
};

/**
 * @description initialise the slick sliders for the page
 */
let initSliders = () => {
  // generic slider example
  // go to - https://kenwheeler.github.io/slick/ - for documentation
  $(".slider").slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  // slider arrow functionality
  // $('.slick-{arrow-name}.slick-prev').click(function () {
  //   $('.{carousel-name}').slick('slickPrev');
  // });
  // $('.slick-{arrow-name}.slick-next').click(function () {
  //   $('.{carousel-name}').slick('slickNext');
  // });
};

/**
 * @description handles opening and closing of the mobile menu on the site
 *
 * @param {*} open flag indicating whether or not the menu is in an open state
 */
var open = false;
let toggleMenu = (open) => {
  $("#burger").toggleClass("open", open);
  $("#navigation-mobile ul").toggleClass("open", open);
};

/**
 * @description centers the map on the current marker or in the center of all markers present
 *
 * @param {*} map the JSON map object being worked on
 */
let centerMap = (map) => {
  let bounds = new google.maps.LatLngBounds();
  $.each(map.markers, function (i, marker) {
    let latlng = new google.maps.LatLng(
      marker.position.lat(),
      marker.position.lng()
    );
    bounds.extend(latlng);
  });
  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());
    map.setZoom(map.zoom);
  } else {
    map.fitBounds(bounds);
  }
};

/**
 * @description adds a new marker to the map being created
 *
 * @param {*} $marker the jQuery HTML marker to be added
 * @param {*} map the JSON map object to be operated on
 */
let addMarker = ($marker, map) => {
  let latlng = new google.maps.LatLng(
    $marker.attr("data-lat"),
    $marker.attr("data-lng")
  );
  let icon = {
    url: "" + $marker.attr("data-icon") + "",
    scaledSize: new google.maps.Size(48, 48),
  };
  let marker = new google.maps.Marker({
    icon: icon,
    map: map,
    position: latlng,
  });
  map.markers.push(marker);
  if ($marker.html()) {
    let infowindow = new google.maps.InfoWindow({
      content: $marker.html(),
    });
    google.maps.event.addListener(marker, "click", function () {
      infowindow.open(map, marker);
    });
  }
};

/**
 * @description creates a new map at the location of the jQuery element passed in
 *
 * @param {*} $el the jQuery element to create a map aroudn
 */
let newMap = ($el) => {
  let $markers = $el.find(".marker");
  let args = {
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: [
      {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#d3d3d3",
          },
        ],
      },
      {
        featureType: "transit",
        stylers: [
          {
            color: "#808080",
          },
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#b3b3b3",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ffffff",
          },
          {
            weight: 1.8,
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#d7d7d7",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ebebeb",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry",
        stylers: [
          {
            color: "#a7a7a7",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#efefef",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#696969",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#737373",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#d6d6d6",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {},
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#dadada",
          },
        ],
      },
    ],
    zoom: 12,
  };
  let map = new google.maps.Map($el[0], args);
  map.markers = [];
  $markers.each(function () {
    addMarker($(this), map);
  });
  centerMap(map);
  return map;
};

/**
 * @description convenience function for running all code required to generate a single (or multiple) maps on a page
 */
let initGoogleMapping = () => {
  $(".map").each(function () {
    newMap($(this));
  });
};

//Replace checkout form select styles with fontawesome
$(document).ready(function() {
  $('.select2-selection').each(function() {
    if (!$(this).find('.fa-chevron-down').length) {  // Prevent duplicate icons
      $(this).append('<i class="fa-solid fa-chevron-down custom-chevron" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); pointer-events: none;"></i>');
    }
  });
});